<template>
    <div>
        <Head :title="`${form.name}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/blocker-keyword-tags">Blocker Keyword Tags</Link>
                <span class="text-indigo-400 font-medium">/</span>
                {{ form.name }}
            </h1>
        </div>
        <div class="w-full bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Name"/>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Update Keyword Tag
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    layout: Layout,
    props: {
        tag: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.tag.name
            }),
        }
    },
    methods: {
        update() {
            this.form.post(`/blocker-keyword-tags/${this.tag.id}`)
        }
    },
}
</script>
